module.exports = __webpack_public_path__ + "img/17854_L.3b6210c6.png";